// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  authCheckRequest: ['data'],
  authCheckSuccess: null,
  authCheckFailure: ['err'],
  authRequest: ['data'],
  authSuccess: ['user'],
  authFailure: ['err'],
  authLogout: null,
  authInit: null
})

export const AuthTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  user: null,
  err: null,
  profileChanged: false,
  passwordChanged: false
})

/* ------------- Reducers ------------- */

// we're attempting to login
export const request = (state: Object) => state.merge({
  fetching: true,
  err: null
})

// we've successfully logged in
export const success = (state: Object, { user }: Object) =>
  state.merge({
    fetching: false,
    err: null,
    user
  })

// we've had a problem logging in
// Possible errors:
// * user pass doesnt match
// * user not registered ?
// * user account not activated ?
// err is string
export const failure = (state: Object, {err}: any) => {
  return state.merge({
    fetching: false,
    err
  })
}

// Set state initial value when user open sign in modal
export const init = (state: Object) => state.merge({
  fetching: false,
  err: null,
  passwordChanged: false
})

export const logout = (state: Object) => state.merge({ user: null, fetching: false, err: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer =
  createReducer(INITIAL_STATE, {
    [Types.AUTH_CHECK_SUCCESS]: success,
    [Types.AUTH_CHECK_REQUEST]: request,
    [Types.AUTH_CHECK_FAILURE]: failure,
    [Types.AUTH_SUCCESS]: success,
    [Types.AUTH_REQUEST]: request,
    [Types.AUTH_FAILURE]: failure,
    [Types.AUTH_LOGOUT]: logout,
    [Types.AUTH_INIT]: init
  })

export const isLoggedIn = (state: Object) => state.user !== null



// WEBPACK FOOTER //
// ./src/Redux/AuthRedux.js